import { useState } from 'react';

const MAX_VALUES = 5;

function ExpandableValues({ values }: { values: string[] }) {
  const [expanded, setExpanded] = useState(false);

  if (values.length <= MAX_VALUES) return <>{values.join(', ')}</>;

  return (
    <>
      {(expanded ? values : values.slice(0, MAX_VALUES)).join(', ')}{' '}
      <button
        type="button"
        className="btn btn-link btn-sm p-0"
        onClick={() => setExpanded(prev => !prev)}
      >
        {expanded ? 'show less' : `+${values.length - MAX_VALUES} more`}
      </button>
    </>
  );
}

export interface FieldValueEntry {
  field: string;
  fieldName: string;
  values: string[];
}

export default function FieldValuesSummary({ entries }: { entries: FieldValueEntry[] }) {
  return (
    <>
      {entries.map((entry, index) => (
        <span key={entry.field}>
          {index > 0 && '; '}
          {entry.fieldName}: <ExpandableValues values={entry.values} />
        </span>
      ))}
    </>
  );
}
